export default function (http) {
    return {
        queryByName (data){
            return http.json({
                url: '/customer/info/queryAll',
                data
            });
        },
        query (data){
            return http.json({
                url: '/customer/info/query',
                data
            });
        },
        getCustomerInfo(data) {
            return http({
                url: `/customer/info/get?id=${data.id}`,
                method: 'post'
            })
        },
        saveCustomerInfo(data) {
            return http.json({
                url: `/customer/info/save`,
                data
            })
        },

        recover(data){
            return http.json({
                url: '/customer/info/recover',
                data
            });
        },
        disable(data){
            return http.json({
                url: '/customer/info/disable',
                data
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/customer.js